import { Checkbox } from '@/components/ui/checkbox';

const ATHENA_URL = 'https://www.athena4partners.org';

type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export default function AthenaOptOutCheckbox({ checked, onChange }: Props) {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <h2 className="text-lg font-semibold">Athena</h2>
        <p className="text-xs text-muted-foreground">
          Athena is a defense collaborative research platform for defense communications and converging research.{' '}
          <a
            href={ATHENA_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary underline hover:text-primary/80"
          >
            Learn more
          </a>
        </p>
        <p className="text-xs text-muted-foreground">Optional — opt out below if you do not want an Athena account</p>
      </div>
      <label
        className={`flex items-start gap-3 p-3 rounded-lg border-2 cursor-pointer transition-all duration-200 ${
          checked
            ? 'border-primary bg-primary/5'
            : 'border-border hover:border-primary/50'
        }`}
      >
        <Checkbox
          checked={checked}
          onCheckedChange={(v) => onChange(v === true)}
          className="h-4 w-4 mt-0.5 shrink-0"
        />
        <span className="text-xs text-foreground leading-relaxed">
          Check this box if you do <strong>not</strong> want to be automatically registered for an Athena account.
        </span>
      </label>
    </div>
  );
}
